<template>
    <div>
        <el-dialog title="自定义下载" width="45%"  :visible.sync="dialogVisible" >
            <el-row>
                <el-col :span="16" class="head" style="margin-text-outline: 20px;">
                选择行政班统计范围
                </el-col>
                <el-col :span="8" class="head3">
                    <el-button type="text" @click="setChecked3(true)">全选</el-button>
                    <el-button type="text" @click="setChecked3(false)">不选</el-button>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" >
                    <div v-if="hardClassList.length > 0">
                        <el-checkbox-group v-model="teachingClass" >
                            <el-checkbox v-for="item in teachingClassList" :key="item.id" :label="item.name">
                                {{item.name}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div v-else><span>暂未设置行政班</span></div>
                
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="16" class="head" style="margin-text-outline: 20px;">
                选择教学班统计范围
                </el-col>
                <el-col :span="8" class="head3">
                    <el-button type="text" @click="setChecked3(true)">全选</el-button>
                    <el-button type="text" @click="setChecked3(false)">不选</el-button>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" >
                    <div v-if="teachingClassList.length > 0">
                    <el-checkbox-group v-model="teachingClass" >
                        <el-checkbox v-for="item in teachingClassList" :key="item.id" :label="item.name">
                            {{item.name}}
                        </el-checkbox>
                    </el-checkbox-group>
                    </div>

                    <div v-else><span>暂未设置行政班</span></div>

                </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
              <el-button type="primary" :loading="loading" @click="submitForm">生成并下载</el-button>

            </div>
            
        </el-dialog>
    </div>
</template>
<script>
    import * as mUtils from '@/utils/mUtils'
    import {mapState, mapActions} from 'vuex'
    import XEUtils from 'xe-utils'
    import * as simpleApi from "request/simple";
    import Pagination from "@/components/pagination";

    export default {
        name: 'downloadScoreCustomDialog',
        data(){
            return {
                dialogVisible: false,
                hardClass: [],
                hardClassList: [],
                teachingClass: [],
                teachingClassList: []
            }
        },
        components:{
            Pagination
        },
        computed:{},
        mounted() {
        },
        methods: {
          // 读取考试教师班配置与老师行政班
          getHardList(examId){
            let param = { controllerName: 'akExam', methodName: '/test', param: {id: examId}};
            simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                debugger
                this.hardClassList = data.hardClass
                this.teachingClassList = data.teachingClass
                this.dialogVisible = true
            });
          },
          showDialog(){
            this.dialogVisible = true
          },
          cancel(){
            
            this.hardClass = [],
            this.teachingClass= [],
            this.dialogVisible = false
          },
          submitForm(){
            // 校验是否勾选
            debugger
          }

        }
    }
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
        .head{
            font-weight: bold;
            font-size: 18px;
            text-align: left;
            float: left;
        }
</style>